import { render } from "./DocumentClassExportInterfaceSubView.vue?vue&type=template&id=85005932&scoped=true&ts=true"
import script from "./DocumentClassExportInterfaceSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportInterfaceSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassExportInterfaceSubView.vue?vue&type=style&index=0&id=85005932&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85005932"]])

export default __exports__